<script setup lang="ts">
import { ref } from 'vue'

import MainPolicySwitcher from '@kidzonet/dashboard-main-policy-switcher'
import BlockSocialMediaIcon from '@kidzonet/dashboard-policy-icons/src/BlockSocialMedia.vue'
import { useDasboardPolicyStore } from '@kidzonet/dashboard-policy-store'
import Switcher from '@kidzonet/dashboard-policy-swithcer'
import PolicyItem from '@kidzonet/dashboard-policy-widget'
import { useSettingsStore } from '@kidzonet/dashboard-settings-store'
import { useLoadLocaleMessages } from '@kidzonet/vue-i18n-package'

useLoadLocaleMessages('policy')

const store = useDasboardPolicyStore()
store.fetchUserPolicies()

const settingsStore = useSettingsStore()

const protectionOnPolicy = ref({ id: 0, name: '', isActive: false })
const protectionOffPolicy = ref({ id: 0, name: '', isActive: false })
const blockSocialMediaPolicy = ref({ id: 0, name: '', isActive: false })

const activateProtectionOn = async () => {
    if (protectionOnPolicy.value.isActive) {
        return
    }
    if (protectionOnPolicy.value.id === undefined) {
        return
    }
    await store.activateProtectionOn()
    settingsStore.safeSearch = true
}

const activateProtectionOff = async () => {
    if (protectionOffPolicy.value.isActive) {
        return
    }
    if (protectionOffPolicy.value.id === undefined) {
        return
    }
    await store.activateProtectionOff('simple')
    settingsStore.safeSearch = false
    settingsStore.safeYoutube = false
}

store.$subscribe(() => {
    if (store.activePolicy === undefined) {
        return
    }

    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-ignore
    protectionOnPolicy.value = store.policyByName('holiday_time')

    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-ignore
    protectionOffPolicy.value = store.policyByName('allow_all')

    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-ignore
    blockSocialMediaPolicy.value = store.policyByName('social_media')
})

const changePolicy = async () => {
    if (store.inactiveSinglePolicy.name === 'holiday_time') {
        await activateProtectionOn()
    } else {
        await activateProtectionOff()
    }
}

const switchSocialMedia = () => store.activatePolicy(blockSocialMediaPolicy.value.id)
</script>

<template>
    <div class="simple-interface-page">
        <div v-if="store.policyList.length > 0">
            <section
                :class="[
                    'kidzonet-dashboard-widget',
                    'simple-interface-content',
                    {
                        'simple-interface-content--visible': blockSocialMediaPolicy.name,
                    },
                ]"
            >
                <MainPolicySwitcher
                    @change-policy="changePolicy"
                />
                <PolicyItem
                    :name="blockSocialMediaPolicy.name"
                    :id="blockSocialMediaPolicy.id"
                    :is-active="blockSocialMediaPolicy.isActive"
                    @click="switchSocialMedia"
                    @keyup.enter="switchSocialMedia"
                >
                    <template #icon>
                        <BlockSocialMediaIcon />
                    </template>
                    <Switcher
                        :model-value="blockSocialMediaPolicy.isActive"
                    />
                </PolicyItem>
            </section>
        </div>
    </div>
</template>

<style>
    .simple-interface-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        block-size: 60vh;
    }
    .simple-interface-content {
        display: flex;
        flex-direction: column;
        gap: 1em;

        min-inline-size: 500px;
        max-inline-size: 500px;

        opacity: 0;

        transition: 0.8s;

        @media(max-width: 800px) {
            min-inline-size: inherit;
        }
    }

    .simple-interface-content--visible {
        opacity: 1;
    }
</style>
